module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/17mill-active-da57c5da414a3b5aa33fd94783bc87cd.png";